<template>
  <div class="col-12 col-md-12 col-lg-10">
    <div class="tit text-center">
      <p>{{stepTitle}}</p>
     <button  type="button" class="btn btn-lg btn-link" @click="showPartnerType = true"><span class="icon icon-plus-circle"></span> Adicionar avalista</button>
    </div>
    
    <div class="row justify-content-center">
      <div class="col-12 col-md-12 col-lg-11 col-xl-11">
        <form @submit="onSubmit">
          <div class="form-row" v-for="(avalista, index) in avalistas" :key="`partnerFields${index}`">
            <div class="col-md-11">
              <company-fields v-if="avalista.Tipo == 2" :partner="avalista" />
              <person-fields v-else :partner="avalista" />
            </div>
            <div class="form-group col-md-1 align-self-center text-center">
              <a v-if="!isMei" @click="removePartner(index)" title="Remover avalista" class="icon icon-minus-circle remove"></a>
            </div>
          </div>
          <div class="btns text-center">
            <button v-if="!isMei" type="button" class="btn btn-lg btn-link" @click="showPartnerType = true"><span class="icon icon-plus-circle"></span> Adicionar avalista</button>

            <at-select v-if="showPartnerType" size="large" placeholder="Tipo de Avalista" @on-change="addPartner">
              <at-option value="1">Pessoa Física</at-option>
              <at-option value="2">Pessoa Jurídica</at-option>
            </at-select>
            <div class="text-center fixedOptions">
              <button class="btn btn-lg btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Masker from "@/utils/masker";
import ArrayHelper from "@/utils/array-helper";
import PersonFields from "@/components/AdditionalInformationPeerToPeer/GuarantorsStep/PersonFields";
import CompanyFields from "@/components/AdditionalInformationPeerToPeer/GuarantorsStep/CompanyFields";

const COMPANY_TYPE_MEI = 1;

export default {
  components: { PersonFields, CompanyFields },
  data() {
    const partners = this.solicitacao.Empresa.Avalistas || [];
    return {
      showPartnerType: false,
      avalistas: partners.map(partner => {
        return {
          Tipo: partner.Tipo,
          Nome: partner.Nome,
          Cpf: partner.Cpf,
          DataNascimento: partner.DataNascimento
            ? new Date(partner.DataNascimento).toLocaleDateString("pt-BR")
            : null,
          Escolaridade: partner.Escolaridade,
          EstadoCivil: partner.EstadoCivil,
          Celular: partner.Celular,
          Email: partner.Email,
          Site: partner.Site,
          Facebook: partner.Facebook,
          Linkedin: partner.Linkedin,
          NomeConjuge: partner.NomeConjuge,
          CpfConjuge: partner.CpfConjuge,
          CelularConjuge: partner.CelularConjuge,
          EmailConjuge: partner.EmailConjuge,
          EscolaridadeConjuge: partner.EscolaridadeConjuge,
          DataNascimentoConjuge: partner.DataNascimentoConjuge
            ? new Date(partner.DataNascimentoConjuge).toLocaleDateString(
                "pt-BR"
              )
            : null,
          RazaoSocial: partner.RazaoSocial,
          Cnpj: partner.Cnpj
        };
      }),
      isMei: this.solicitacao.Empresa.TipoEmpresa == COMPANY_TYPE_MEI,
      errors: []
    };
  },
  props: {
    solicitacao: { required: true, type: Object }
  },
  computed: {
    stepTitle: function() {
      if (this.avalistas.length == 1) {
        return "Os dados do avalista abaixo estão corretos?";
      } else {
        return "Os dados dos avalistas abaixo estão corretos?";
      }
    }
  },
  methods: {
    validate() {
      let hasEmptyFields = false;
      Array.forEach(this.avalistas, partner => {
        if (
          partner.Tipo == 1 &&
          (partner.Nome == null ||
            partner.Cpf == null ||
            partner.Escolaridade == null,
          partner.EstadoCivil == null)
        ) {
          hasEmptyFields = true;
        }
        if (partner.Tipo == 2 && (!partner.RazaoSocial || !partner.Cnpj)) {
          hasEmptyFields = true;
        }
      });

      const errors = hasEmptyFields
        ? [
            "Nessa etapa é obrigatório o preenchimento de todos as informações solicitadas"
          ]
        : [];
      return { isValid: !hasEmptyFields, errors: errors };
    },
    onSubmit(e) {
      e.preventDefault();
      const validation = this.validate();

      if (validation.isValid) {
        //Trecho de código para atualizar os socios na parte de avalistas

        this.solicitacao.Empresa.Socios.filter(socio => {
          if (socio.EstadoCivil === 2 || socio.EstadoCivil === 5) return true;
          else return false;
        }).map((socio) => {
          this.avalistas.filter(avalista => {
              if (
                socio.Cpf == avalista.CpfConjuge &&
                avalista.CpfConjuge == socio.Cpf ||

                socio.Email == avalista.EmailConjuge &&
                avalista.EmailConjuge == socio.Email 
              )
                return true;
              else return false;
            })
            .map(avalista => {
              var dataNascAvalista = null;
              var dataNascAvalistaConjuge = null;

              if (
                avalista.DataNascimento !== null &&
                avalista.DataNascimento !== undefined
              ) {
                dataNascAvalista = new Date(
                  avalista.DataNascimento.replace(
                    /(\d{2})\/(\d{2})\/(\d{4})/,
                    "$3/$2/$1"
                  )
                );
              }

              if (
                avalista.DataNascimentoConjuge !== null &&
                avalista.DataNascimentoConjuge !== undefined
              ) {
                dataNascAvalistaConjuge = new Date(
                  avalista.DataNascimentoConjuge.replace(
                    /(\d{2})\/(\d{2})\/(\d{4})/,
                    "$3/$2/$1"
                  )
                );
              }
              var indexSocios = this.solicitacao.Empresa.Socios.indexOf(socio)

              this.solicitacao.Empresa.Socios[indexSocios].Nome = avalista.NomeConjuge;
              this.solicitacao.Empresa.Socios[indexSocios].DataNascimento = dataNascAvalistaConjuge;
              this.solicitacao.Empresa.Socios[indexSocios].Cpf = Masker.unmaskCpf(avalista.CpfConjuge);
              this.solicitacao.Empresa.Socios[indexSocios].EstadoCivil = avalista.EstadoCivil;
              this.solicitacao.Empresa.Socios[indexSocios].Escolaridade = avalista.EscolaridadeConjuge;
              this.solicitacao.Empresa.Socios[indexSocios].Celular = avalista.CelularConjuge;
              this.solicitacao.Empresa.Socios[indexSocios].Email = avalista.EmailConjuge;
              this.solicitacao.Empresa.Socios[indexSocios].NomeConjuge = avalista.Nome;
              this.solicitacao.Empresa.Socios[indexSocios].CpfConjuge = Masker.unmaskCpf(avalista.Cpf);
              this.solicitacao.Empresa.Socios[indexSocios].DataNascimentoConjuge = dataNascAvalista;
              this.solicitacao.Empresa.Socios[indexSocios].CelularConjuge = avalista.Celular;
              this.solicitacao.Empresa.Socios[indexSocios].EmailConjuge = avalista.Email;
              this.solicitacao.Empresa.Socios[indexSocios].EscolaridadeConjuge = avalista.Escolaridade;
            });
        });

        var newData = {
          Empresa: {
            Avalistas: this.avalistas.map(avalista => {
              var dataNascAvalista = null;
              var dataNascAvalistaConjuge = null;

              if (
                avalista.DataNascimento !== null &&
                avalista.DataNascimento !== undefined
              ) {
                dataNascAvalista = new Date(
                  avalista.DataNascimento.replace(
                    /(\d{2})\/(\d{2})\/(\d{4})/,
                    "$3/$2/$1"
                  )
                );
              }

              if (
                avalista.DataNascimentoConjuge !== null &&
                avalista.DataNascimentoConjuge !== undefined
              ) {
                dataNascAvalistaConjuge = new Date(
                  avalista.DataNascimentoConjuge.replace(
                    /(\d{2})\/(\d{2})\/(\d{4})/,
                    "$3/$2/$1"
                  )
                );
              }
              if (avalista.Tipo == 1) {
                return {
                  Tipo: avalista.Tipo,
                  Nome: avalista.Nome,
                  DataNascimento: dataNascAvalista,
                  Cpf: Masker.unmaskCpf(avalista.Cpf),
                  Escolaridade: avalista.Escolaridade,
                  EstadoCivil: avalista.EstadoCivil,
                  Celular: avalista.Celular,
                  Email: avalista.Email,
                  Facebook: avalista.Facebook,
                  Linkedin: avalista.Linkedin,
                  NomeConjuge:
                    avalista.EstadoCivil === 2 || avalista.EstadoCivil === 5
                      ? avalista.NomeConjuge
                      : "",
                  CpfConjuge:
                    avalista.EstadoCivil === 2 || avalista.EstadoCivil === 5
                      ? avalista.CpfConjuge
                      : "",
                  DataNascimentoConjuge:
                    avalista.EstadoCivil === 2 || avalista.EstadoCivil === 5
                      ? dataNascAvalistaConjuge
                      : null,
                  EmailConjuge:
                    avalista.EstadoCivil === 2 || avalista.EstadoCivil === 5
                      ? avalista.EmailConjuge
                      : "",
                  CelularConjuge:
                    avalista.EstadoCivil === 2 || avalista.EstadoCivil === 5
                      ? avalista.CelularConjuge
                      : "",
                  EscolaridadeConjuge:
                    avalista.EstadoCivil === 2 || avalista.EstadoCivil === 5
                      ? avalista.EscolaridadeConjuge
                      : 0
                };
              } else {
                return {
                  Tipo: avalista.Tipo,
                  RazaoSocial: avalista.RazaoSocial,
                  Cnpj: avalista.Cnpj,
                  Site: avalista.Site,
                  Celular: avalista.Celular,
                  Email: avalista.Email,
                  Facebook: avalista.Facebook,
                  Linkedin: avalista.Linkedin
                };
              }
            }),
            Socios: this.solicitacao.Empresa.Socios
          }
        };

        this.$emit("on-submit", newData);
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: ArrayHelper.toSentence(validation.errors)
        });
      }
    },
    addPartner(partnerType) {
      this.avalistas.push({ Tipo: Number.parseInt(partnerType) });
      this.showPartnerType = false;
    },
    removePartner(index) {
      this.avalistas.splice(index, 1);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/GuarantorsStep.vue